import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore';
import {quizSessionDbSchema} from './quizSessionDbSchema';

/** Output schema for use (with id from document id; dates as Date). */
export const quizSessionSchema = quizSessionDbSchema.extend({
  id: z.string(),
  startedAt: firestoreTimestampToDateSchema,
  endedAt: firestoreTimestampToDateSchema.nullable().optional(),
});

export interface QuizSession extends z.infer<typeof quizSessionSchema> {}
/** QuizSession with computed score (e.g. for list display). */
export type QuizSessionWithScore = QuizSession & {score: number};
